export default __webpack_public_path__ + "static/media/warrnty_card.4f058400.pdf";